import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationModalComponent } from '../components/authentication-modal/authentication-modal.component';
import { Subject } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { takeUntil } from 'rxjs/operators';
import { AuthenticationDataService } from './authentication-data.service';
import moment, { Moment } from 'moment';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root'  
})
export class AuthenticationNumberService {
  private ngUnsubscribe = new Subject();

  constructor(
    //private modalService: NgbModal,
    //private authenticationDataService: AuthenticationDataService,
    private authenticationService: AuthenticationService,
    protected appConfigService: AppConfigService
  ) { }

  private isAuthenticated = false;
  private readonly DATE_TIME_FORMAT = 'HH:mm';
  private now: Moment;

  public setAuthenticationTimeout(username: string, timeout: number): void {
    var user = this.authenticationService.getAuthorizedUser();
    if (user && user != null) {
      this.now = moment(new Date(), this.DATE_TIME_FORMAT);
      sessionStorage.setItem("next-auth-event", this.now.add((timeout / (60 * 60 * 1000)), 'hours').toLocaleString());
      sessionStorage.setItem("username", username);
      const timeoutId = setTimeout(() => {
        this.authenticationService.logout(true);

        //console.log("delayed authentication token");
        //this.authenticationDataService.sendAuthenticationNumber(username)
        //  .pipe(
        //    takeUntil(this.ngUnsubscribe))
        //  .subscribe(
        //    response => {
        //      if (response) {
        //        const modalRef = this.modalService.open(AuthenticationModalComponent, { backdrop: 'static', centered: true });
        //        modalRef.componentInstance.username = username;
        //        modalRef.componentInstance.isAfterLogin = true;
        //        sessionStorage.setItem("modal-open", "true");
        //        modalRef.componentInstance.modalConfirmed
        //          .pipe(takeUntil(this.ngUnsubscribe))
        //          .subscribe((result: boolean) => {
        //            if (result) {
        //              modalRef.componentInstance.isAfterLogin = false;
        //              sessionStorage.removeItem("modal-open");
        //              this.isAuthenticated = result;
        //              console.log("confirmed : " + result);
        //              modalRef.close();
        //              this.setAuthenticationTimeout(username, this.appConfigService.getConfig().AuthTimeout);
        //            }
        //          });
        //        modalRef.componentInstance.modalResend
        //          .pipe(takeUntil(this.ngUnsubscribe))
        //          .subscribe((result: boolean) => {
        //            console.log("resend : " + result);
        //          });

        //        modalRef.componentInstance.modalClosed
        //          .pipe(takeUntil(this.ngUnsubscribe))
        //          .subscribe(() => {
        //            if (!this.isAuthenticated) {
        //              this.authenticationService.logout(true);
        //            }
        //            modalRef.close();
        //          });
        //      }
        //    });
      }, timeout);
      sessionStorage.setItem("timeoutId", timeoutId+"");
    }
  }
}
